import React from 'react';
import MessageCell from '@/components/table/MessageCell';

const VocabularyEmailCell = ({ vocabulary }) => (
  <MessageCell
    className="td-description"
    messageId="vocabulary.email.subject"
    messageArgs={{ subject: vocabulary.email.subject }}
  />
);

export default VocabularyEmailCell;
